import React from 'react';
import { TcsmParagraphBlock } from '../../models/tcsm-block-models';
import { PageHeader } from '../layout/page-header';
import { WysiwygWithReactLink } from '../wysiwyg-with-react-link';


interface Props {
    blockData: TcsmParagraphBlock,
}

export function TcsmParagraphBlockView(props: Props){

    const { blockData } = props;        

    return (
        <section className="adage-block">
            <PageHeader headerText={blockData?.title} />                
            <WysiwygWithReactLink content={blockData?.content} />            
        </section>
    );
}

export default TcsmParagraphBlockView;
